import { tmrDialogController } from 'tmr/controllers/dialog/dialog'
import templateUrl from './sessionTransferToZoneDialog.html'
import './sessionTransferToZoneDialog.scss'

/**
 * Configures dialog Items by Upc (preset `tmrSessionTransferToZone`).
 *
 * @type {ngConfig}
 */
function tmrSessionTransferToZoneDialogConfig($mdDialogProvider) {
  'ngInject'
  $mdDialogProvider.addPreset('tmrSessionTransferToZone', {
    options: /*@ngInject*/ () => ({
      templateUrl,
      clickOutsideToClose: false,
      fullscreen: true,
      controller: 'tmrSessionTransferToZoneDialogController',
      controllerAs: '$ctrl',
      bindToController: true,
      locals: {
        parcel: {},
      },
    }),
  })
}

export { tmrSessionTransferToZoneDialogConfig as config }

/**
 * Controller of Dialog {@link tmrSessionTransferToZoneDialogConfig tmrSessionTransferToZone}.
 *
 * @type {ngController}
 */
export class tmrSessionTransferToZoneDialogController extends tmrDialogController {
  constructor($mdDialog, $transitions) {
    'ngInject'
    super($mdDialog, $transitions)
  }

  onCallBackSession(action) {
    this.$mdDialog.hide(action)
  }

  // abort phase to phase process
  onClickAbort() {
    this.$mdDialog.hide()
  }
}
